import React from 'react';
import { FollowUsItem } from '../types';

interface FollowUsListProps {
    followUs: FollowUsItem[];
}

function FollowUsList({ followUs }: FollowUsListProps) {
    return (
        <div className="followUsList">
            <div className="followUsTitle"> Follow us on: </div>
            {followUs.map((icon, index) => (
                <a
                    key={index}
                    href={icon.url}
                    aria-label={`Visit us on ${icon.alt}`}
                    title={icon.alt}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {React.createElement(icon.imgComponent)}
                </a>
            ))}
        </div>
    );
}

export default FollowUsList;
